import type { AnalyticsPlacementTypes } from '@core/analytics'
import type { TEmbedConfig } from '@core/models'
import { createStoreChunk } from '@core/store'

type TShareEntityCommon = {
    /** Entity id — used as the analytics id and (for audio/collection) the share_button_click payload. */
    id: string
    /** Human title, used as the tweet text. */
    title: string
    /** Placement for share_button_click; omitted for entities without a player context (category). */
    placement?: AnalyticsPlacementTypes
}

export type TShareAudioEntity = TShareEntityCommon & {
    item: 'audio'
    authorUsername: string
    audioSlug: string
    /** Owner viewing their own audio — suppresses share_type_click (parity with audio-web). */
    isOwner?: boolean
}

export type TShareCollectionEntity = TShareEntityCommon & {
    item: 'collection'
    authorUsername: string
    collectionSlug: string
    itemsCount: number
    isOwner?: boolean
}

export type TShareCategoryEntity = TShareEntityCommon & {
    item: 'category'
    categoryType: string
    tagSlug: string
}

export type TShareEntity = TShareAudioEntity | TShareCollectionEntity | TShareCategoryEntity

/** In-progress embed config, kept so it survives the paywall round-trip (the dialog is unmounted). */
export type TEmbedDraft = {
    config: TEmbedConfig
    width: number
}

// Both the share and embed dialogs read this single entity — only one is ever open at a time.

type TShareState = {
    entity: TShareEntity | null
    embedDraft: TEmbedDraft | null
}

export const shareStore = createStoreChunk<TShareState>('share')({
    initialState: { entity: null, embedDraft: null },
})
